import { api } from '@/lib/api/client';

/** A device as its owner sees it (sreg-api never returns the device's cookie id). */
export interface VerifiedDevice {
  id: string;
  name?: string;
  platform?: string;
  operatingSystem?: string;
  lastAuthentication?: string;
  mfaVerifiedAt?: string;
  /** The browser making this request. */
  current: boolean;
}

export const MIN_PASSWORD_LENGTH = 8;

export function updateName(profileId: string, firstName: string, lastName: string): Promise<unknown> {
  const displayName = `${firstName} ${lastName}`.trim();
  const initials = `${firstName[0] ?? ''}${lastName[0] ?? ''}`.toUpperCase();
  return api.patch(`/profile/${profileId}`, { firstName, lastName, displayName, initials });
}

/** Sets a new password; the current one isn't asked for (the session is device-verified). */
export function setPassword(userId: string, password: string): Promise<unknown> {
  return api.put(`/user/${userId}`, { id: userId, password });
}

export function listDevices(signal?: AbortSignal): Promise<VerifiedDevice[]> {
  return api.get<VerifiedDevice[]>('/device', undefined, signal);
}

/** Clears a device's verification: it needs an emailed code again. Not the current device. */
export function invalidateDevice(id: string): Promise<unknown> {
  return api.put(`/device/${id}/invalidate`);
}
